import React from "react";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import Button, { ButtonSize } from "../../Buttons/Button";

interface Props extends ToolNavigationItem {
    targetDevice: "mobile" | "desktop";
}

const getButtonSizeClass = (fontsize: string): ButtonSize => {
    let className: ButtonSize;
    
    switch (fontsize) {
        case "desktop":
            className = ButtonSize.Small50;
            break;
            
        default:
        case "mobile":
            className = ButtonSize.Small;
            break;
    }

    return className;
};

export const CallToActionToolLink = (props: Props) => {
    const buttonSizeClass = getButtonSizeClass(props.targetDevice);
    return (
        <Button 
            {...props.link} 
            color="secondary" 
            size={buttonSizeClass} 
            type="link">
            {props.title}
        </Button>
    );
};